import US from './US.js';
import CA from './CA.js';
import Other from './Other.js';

var countries = {
  US: US,
  CA: CA,
  Other: Other
};

export { countries as default };
//# sourceMappingURL=index.js.map
